import React from 'react'
 import useSEO from "./useSEO";

const Taxdeductedatsource = () => {
  useSEO({ 
  title: "Tax Deducted at Source (TDS) Services | TDS Filing & Compliance Experts in Hyderabad",
  description: "Ensure accurate TDS calculation, deduction, and filing with our professional TDS services in Hyderabad. We handle TDS compliance, returns, challans, and reconciliation to help businesses avoid penalties and stay compliant.",
  keywords: "TDS services Hyderabad, TDS filing, TDS compliance, TDS return filing, TDS calculation, TDS reconciliation, TDS challan payment, TDS consultants Hyderabad",
  ogTitle: "TDS Services - Trusted Hyderabad Experts",
  ogDescription: "Accurate and timely TDS filing and compliance services for businesses in Hyderabad.",
  ogImage: "img/tds-services.png",
  twitterTitle: "TDS Services - Trusted Hyderabad Experts",
  twitterDescription: "Avoid penalties and ensure compliance with expert TDS services in Hyderabad.",
  twitterImage: "img/tds-services.png"
});
  return (
    <div>

        <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4">Tax Deducted at Source (TDS) Services</h1>
          <p className="mb-4">
            {" "}
            We have tremendous experience team with decades of experience to
            provide complete TDS services to ensure timely deductions, accurate
            filings, and full regulatory compliance—minimizing the risk of
            interest, penalties, and legal issues.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img
            src="img/tax-deducted-at-source-tds.png"
            alt="Tax Deducted at Source (TDS) Services"
          />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img
              src="img/tax-deducted-at-source-tds1.png"
              alt="Tax Deducted at Source (TDS) Services"
            />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> Our TDS Services Include:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> TAN Application &amp; TDS Registration</b>
                </li>
                <p>
                  Assistance with obtaining Tax Deduction and Collection Account
                  Number (TAN).
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>TDS Calculation &amp; Deduction Support</b>
                </li>
                <p>
                  {" "}
                  Correct computation of TDS amounts as per current tax laws.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>TDS Return Filing (Form 24Q, 26Q, 27Q, etc.)</b>
                </li>
                <p>
                  Timely preparation and e-filing of quarterly TDS returns with
                  reconciliation.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Form 16 &amp; 16A Generation</b>
                </li>
                <p>Issuance of TDS certificates to employees and vendors.</p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>TDS Payment &amp; Challan Generation</b>
                </li>
                <p>Support in timely payment and generation of TDS challans.</p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>TDS Reconciliation with Form 26AS</b>
                </li>
                <p>Ensuring accurate credit in the recipient's tax records.</p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>TDS Notices &amp; Compliance Handling</b>
                </li>
                <p>
                  {" "}
                  Representation and response to TDS-related notices from the
                  Income Tax Department.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

      
    </div>
  )
}

export default Taxdeductedatsource
